import { Component, inject } from '@angular/core';
import { CoreModule } from './core/core.module';
import { LayoutComponent } from './core/layout/layout.component';
import { ThemeService } from './core/theming/theme.service';
import { UserStateSyncService } from './features/shared/navigation-history/services/user-state-sync.service';
import { DevErrorOverlayComponent } from './features/shared/dev-error/dev-error-overlay.component';
import { FaviconService } from './infrastructure/services/favicon-services/favicon.service';
import { TitleService } from './infrastructure/services/title-services/title.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [
        CoreModule,
        LayoutComponent,
        DevErrorOverlayComponent,
    ]
})

export class AppComponent {
    private __themeService = inject(ThemeService);
    private __faviconService = inject(FaviconService);
    private __titleService = inject(TitleService);
    // Start de centrale backend-synchronisatie van de geconsolideerde user-boom.
    private __userStateSync = inject(UserStateSyncService);
    title = 'app';
}
